import React from "react";
import "./Home.css";
import Header from "./Header";
import "../App.css";
import MedicaxTestimonials from "./MedicaxTestimonials";
import WorksSection from "./WorksSection";
import TeamSection from "./TeamSection";

import Blogs from "./Blogs";
import HomeAboutSection from "./HomeAboutSection";
import Service from "./Service";

function Home() {
  const openMenu = () => {
    console.log("Menu open from Home");
  };
  return (
    <>
      {/*=====HEADER START=======*/}
      {/* <Header onMenuOpen={openMenu} /> */}
      {/*=====HEADER END =======*/}

      {/*===== MOBILE HEADER STARTS =======*/}
      {/*   <div className="homepage4-body">
          <div className="vl-offcanvas">
            <div className="vl-offcanvas-wrapper">
              <div className="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                <div className="vl-offcanvas-logo">
                  <a href="index.html">
                    <img src="assets/img/logo/logo1.png" alt="" />
                  </a>
                </div>
                <div className="vl-offcanvas-close">
                  <button className="vl-offcanvas-close-toggle">
                    <i className="fa-solid fa-xmark" />
                  </button>
                </div>
              </div>

              <div className="vl-offcanvas-menu d-lg-none mb-40">
                <nav />
              </div>

              <div className="space20" />
              <div className="vl-offcanvas-info">
                <h3 className="vl-offcanvas-sm-title">Contact Us</h3>
                <div className="space20" />
                <span>
                  <a href="#">
                    {" "}
                    <i className="fa-regular fa-envelope" /> +57 9954 6476
                  </a>
                </span>
                <span>
                  <a href="#">
                    <i className="fa-solid fa-phone" /> hello@exdos.com
                  </a>
                </span>
                <span>
                  <a href="#">
                    <i className="fa-solid fa-location-dot" /> Bhemeara,Kushtia
                  </a>
                </span>
              </div>
              <div className="space20" />
              <div className="vl-offcanvas-social">
                <h3 className="vl-offcanvas-sm-title">Follow Us</h3>
                <div className="space20" />
                <a href="#">
                  <i className="fab fa-facebook-f" />
                </a>
                <a href="#">
                  <i className="fab fa-twitter" />
                </a>
                <a href="#">
                  <i className="fab fa-linkedin-in" />
                </a>
                <a href="#">
                  <i className="fab fa-instagram" />
                </a>
              </div>
            </div>
          </div>
          <div className="vl-offcanvas-overlay" />
        </div> */}
      {/*===== MOBILE HEADER STARTS =======*/}

      {/*===== HERO AREA STARTS =======*/}
      <div
        className="hero4-section-area"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="hero-header heading4">
                <img
                  src="assets/img/elements/elements12.png"
                  alt=""
                  className="elements12 keyframe3"
                />
                <h5 data-aos="fade-left" data-aos-duration="800">
                  What’s new<span> | </span>Trusted Multispeciality Care{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                  >
                    <path
                      d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992"
                      stroke="#b2442c"
                      strokeWidth={1.5}
                    />
                  </svg>
                </h5>
                <div className="space16" />
                <h1 className="left-text text-anime-style-3">
                  Your Health Comes First, Every Time at JEEVANDAAN <br></br>
                  Hospital.
                </h1>
                <div className="space20" />
                <p
                  className="left-text"
                  data-aos="fade-left"
                  data-aos-duration="900"
                >
                  Welcome to JEEVANDAAN Hospital, a trusted multispeciality
                  hospital offering advanced medical care, expert doctors, and
                  compassionate treatment - because every life truly matters.{" "}
                </p>
                <div className="space40" />
                <div
                  className="btn-area1"
                  data-aos="fade-le"
                  data-aos-duration="1000"
                >
                  <a href="contact.html" className="vl-btn4">
                    Get Expert Medical Care Today{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="hero4-images-area">
                {/*  <div className="bg-area">
                  <img
                    src="assets/img/all-images/bg/hero-bg2.png"
                    alt=""
                    className="hero-bg2"
                  />
                </div> */}
                <div className="img1 text-end">
                  <img
                    src="assets/img/all-images/hero/Herobanner-img.png"
                    alt=""
                  />
                </div>
                <div className="icons-area">
                  <div className="icons1">
                    <img src="assets/img/icons/2.svg" alt="" />
                  </div>

                  <div className="icons2">
                    <img src="assets/img/icons/3.svg" alt="" />
                  </div>

                  <div className="icons3">
                    <img src="assets/img/icons/1.svg" alt="" />
                  </div>

                  <div className="icons4">
                    <img src="assets/img/icons/3.svg" alt="" />
                  </div>

                  <div className="icons5">
                    <img src="assets/img/icons/2.svg" alt="" />
                  </div>

                  <div className="icons6">
                    <img src="assets/img/icons/1.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA ENDS =======*/}

      {/*===== ABOUT AREA STARTS =======*/}
      <HomeAboutSection />
      {/*===== ABOUT AREA ENDS =======*/}
      <div className="slider4-section-area">
        <div className="marquee-wrap">
          <div className="marquee-text">
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Personalized Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Experienced Professionals
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" /> Advanced
                Technology
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Preventive Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Patient-Centered Approach
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Personalized Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Experienced Professionals
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                {" "}
                <img src="assets/img/elements/elements1.png" alt="" />
                Advanced Technology
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Preventive Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Patient-Centered Approach
              </h3>
            </div>
            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Personalized Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Experienced Professionals
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" /> Advanced
                Technology
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Preventive Care
              </h3>
            </div>

            <div className="brand-single-box">
              <h3>
                <img src="assets/img/elements/elements1.png" alt="" />{" "}
                Patient-Centered Approach
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/*===== SERVICE AREA STARTS =======*/}
      <Service />

      {/*===== SERVICE AREA STARTS =======*/}
      <div className="service-benefites-section-area sp2">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="heading4 text-center">
                <h5 className="vl-section-subtitle">
                  JEEVANDAAN Hospital<span> | </span>Why Choose Us{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                  >
                    <path
                      d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992"
                      stroke="#b2442c"
                      strokeWidth="1.5"
                    />
                  </svg>
                </h5>
              </div>
            </div>
          </div>

          {/* h2 full width */}
          <div className="row">
            <div className="col-10 mx-auto">
              <div className="heading4 text-center space-margin60">
                <h2 className="vl-section-title text-anime-style-3">
                  Your Trusted Choice for Exceptional Healthcare
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="benefites-box">
                <div className="star">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="keyframe4"
                    width="75"
                    height="80"
                    viewBox="0 0 75 80"
                    fill="none"
                  >
                    <path
                      d="M74.0861 24.6187L68.8392 15.3742C68.5025 14.7708 68.0485 14.2406 67.5038 13.8147C66.9591 13.3888 66.3346 13.0757 65.6671 12.8939C64.9995 12.7121 64.3023 12.6651 63.6164 12.7559C62.9304 12.8466 62.2696 13.0731 61.6725 13.4222L48.0834 21.5111V5.33333C48.0957 3.9317 47.55 2.58254 46.5661 1.58243C45.5822 0.582328 44.2407 0.0131427 42.8366 0H31.9582C30.554 0.0131427 29.2125 0.582328 28.2286 1.58243C27.2448 2.58254 26.699 3.9317 26.7113 5.33333V21.5111L13.1116 13.4293C12.5145 13.0803 11.8536 12.8537 11.1677 12.763C10.4817 12.6723 9.78452 12.7192 9.11698 12.901C8.44944 13.0828 7.82499 13.3959 7.28027 13.8218C6.73555 14.2477 6.28152 14.7779 5.94482 15.3813L0.708663 24.6187C0.010396 25.8424 -0.17966 27.2905 0.179256 28.6524C0.538172 30.0143 1.41748 31.1817 2.62859 31.904L16.4136 40L2.62146 48.096C1.41156 48.8195 0.533753 49.9873 0.176194 51.3492C-0.181366 52.711 0.0097817 54.1585 0.708663 55.3813L5.95194 64.6258C6.28864 65.2292 6.74267 65.7594 7.28739 66.1853C7.83212 66.6112 8.45656 66.9243 9.1241 67.1061C9.79165 67.2879 10.4888 67.3348 11.1748 67.2441C11.8607 67.1534 12.5216 66.9268 13.1187 66.5778L26.7113 58.4889V74.6667C26.7207 76.0783 27.2866 77.4294 28.2866 78.4276C29.2866 79.4258 30.6402 79.9907 32.0544 80H42.7404C44.1546 79.9907 45.5082 79.4258 46.5082 78.4276C47.5081 77.4294 48.0741 76.0783 48.0834 74.6667V58.4889L61.6832 66.5849C62.2802 66.934 62.9411 67.1605 63.6271 67.2512C64.313 67.342 65.0102 67.295 65.6778 67.1132C66.3453 66.9314 66.9698 66.6184 67.5145 66.1924C68.0592 65.7665 68.5132 65.2363 68.8499 64.6329L74.0968 55.3884C74.795 54.1647 74.9851 52.7166 74.6262 51.3547C74.2673 49.9928 73.388 48.8254 72.1768 48.1031L58.3847 40L72.1768 31.904C73.3861 31.1799 74.2632 30.0118 74.6201 28.65C74.977 27.2882 74.7853 25.8411 74.0861 24.6187Z"
                      fill="#b2442c"
                    />
                  </svg>
                </div>
                <div className="row medicax-feature-row">
                  {/* Card 1 */}
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="900"
                  >
                    <div className="medicax-feature-card">
                      <div className="medicax-feature-icon">
                        <img src="assets/img/icons/1.svg" alt="" />
                      </div>

                      <div className="medicax-feature-content">
                        <a
                          href="service-single.html"
                          className="medicax-feature-title"
                        >
                          Compassionate Care
                        </a>

                        <p>
                          We believe in treating patients with empathy, dignity,
                          and respect, ensuring every individual feels heard,
                          supported, and cared for.
                        </p>

                        <a
                          href="service-single.html"
                          className="medicax-feature-link"
                        >
                          Learn More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301L9.52852 7.52827C9.78887 7.78861 9.78887 8.21072 9.52852 8.47107L7.33325 10.6663"
                              fill="#b2442c"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <div className="medicax-feature-card">
                      <div className="medicax-feature-icon">
                        <img src="assets/img/icons/hero-icon4.svg" alt="" />
                      </div>

                      <div className="medicax-feature-content">
                        <a
                          href="service-single.html"
                          className="medicax-feature-title"
                        >
                          Experienced Medical Professionals
                        </a>

                        <p>
                          Our team of skilled and experienced doctors is
                          dedicated to delivering safe, reliable, and
                          high-quality medical care across specialties.
                        </p>

                        <a
                          href="service-single.html"
                          className="medicax-feature-link"
                        >
                          Learn More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301L9.52852 7.52827C9.78887 7.78861 9.78887 8.21072 9.52852 8.47107L7.33325 10.6663"
                              fill="#b2442c"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="1100"
                  >
                    <div className="medicax-feature-card">
                      <div className="medicax-feature-icon">
                        <img src="assets/img/icons/3.svg" alt="" />
                      </div>

                      <div className="medicax-feature-content">
                        <a
                          href="service-single.html"
                          className="medicax-feature-title"
                        >
                          Patient-Centric Approach
                        </a>

                        <p>
                          At JEEVANDAAN Hospital, your health comes first. We
                          focus on personalized treatment plans and partner with
                          you throughout your healthcare journey.
                        </p>

                        <a
                          href="service-single.html"
                          className="medicax-feature-link"
                        >
                          Learn More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301L9.52852 7.52827C9.78887 7.78861 9.78887 8.21072 9.52852 8.47107L7.33325 10.6663"
                              fill="#b2442c"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Card 4 */}
                  <div
                    className="col-lg-6 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                  >
                    <div className="medicax-feature-card">
                      <div className="medicax-feature-icon">
                        <img src="assets/img/icons/2.svg" alt="" />
                      </div>

                      <div className="medicax-feature-content">
                        <a
                          href="service-single.html"
                          className="medicax-feature-title"
                        >
                          Advanced Medical Technology
                        </a>

                        <p>
                          We use modern medical equipment and advanced
                          diagnostic technology to ensure accurate diagnosis and
                          effective treatment outcomes.
                        </p>

                        <a
                          href="service-single.html"
                          className="medicax-feature-link"
                        >
                          Learn More
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301L9.52852 7.52827C9.78887 7.78861 9.78887 8.21072 9.52852 8.47107L7.33325 10.6663"
                              fill="#b2442c"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== SERVICE AREA ENDS =======*/}

      {/*===== TESTIMONIAL AREA STARTS =======*/}
      <MedicaxTestimonials />

      <>
        {/*===== TESTIMONIAL AREA ENDS =======*/}

        {/*===== WORKS AREA STARTS =======*/}
        <WorksSection />

        {/*===== WORKS AREA ENDS =======*/}

        {/*===== TEAM AREA STARTS =======*/}
        <TeamSection />
        {/*===== TEAM AREA ENDS =======*/}
        {/*===== BLOGS AREA STARTS =======*/}
        <Blogs />
        {/*===== BLOGS AREA ENDS =======*/}
        {/*===== FOOTER AREA STARTS =======*/}

        {/*===== FOOTER AREA END =======*/}
      </>
    </>
  );
}

export default Home;
